import { api } from './api';

interface DebugSettings {
  enabled: boolean;
  updated_by?: string;
  updated_at?: string;
}

interface CreateJobResponse {
  job_id: string;
}

export const adminApi = {
  /**
   * Gets the current global debug settings
   * @returns Promise with the debug settings data
   */
  getDebugSettings: async (): Promise<DebugSettings> => {
    const response = await api.get<DebugSettings>('/settings/debug', {
      is_global: true
    });
    return response.data;
  },

  /**
   * Updates the global debug settings
   * @param enabled - Whether debug mode should be enabled
   * @returns Promise with the updated debug settings
   */
  updateDebugSettings: async (enabled: boolean): Promise<{ enabled: boolean }> => {
    const response = await api.put<{ enabled: boolean }>('/settings/debug', { enabled }, {
      is_global: true
    });
    return response.data;
  },

  /**
   * Sync Maryland bills for a specific session
   * @param session - The legislative session to sync (e.g., '2024RS', '2025RS')
   * @param maxBills - Maximum number of bills to sync (optional)
   * @returns Promise with the job ID
   */
  syncMarylandBills: async (session?: string, maxBills?: number): Promise<CreateJobResponse> => {
    let url = '/jobs/sync-maryland';
    const params = new URLSearchParams();
    
    if (session) {
      params.append('session', session);
    }
    if (maxBills && maxBills > 0) {
      params.append('max_bills', maxBills.toString());
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    const response = await api.post<CreateJobResponse>(url);
    return response.data;
  }
};